import React, { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState([]); // {key, game_id, game_name, slat_id, slat_name, number, quantity, rate}

  const addItem = useCallback((item) => {
    setItems((prev) => {
      const key = `${item.game_id}-${item.slat_id}-${item.number}-${item.rate_type || "customer"}-${item.mode || "direct"}`;
      const existing = prev.find((p) => p.key === key);
      if (existing) {
        return prev.map((p) => (p.key === key ? { ...p, quantity: p.quantity + item.quantity } : p));
      }
      return [...prev, { ...item, key }];
    });
  }, []);

  const removeItem = useCallback((key) => setItems((prev) => prev.filter((p) => p.key !== key)), []);
  const updateQty = useCallback(
    (key, qty) => setItems((prev) => prev.map((p) => (p.key === key ? { ...p, quantity: Math.max(1, qty) } : p))),
    []
  );
  const clear = useCallback(() => setItems([]), []);
  const removeByGame = useCallback((gameId) => setItems((prev) => prev.filter((p) => p.game_id !== gameId)), []);

  const total = items.reduce((s, i) => s + i.rate * i.quantity * (i.perms || 1), 0);
  const count = items.reduce((s, i) => s + i.quantity * (i.perms || 1), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, removeByGame, total, count }}>
      {children}
    </CartContext.Provider>
  );
}
